export const parseJwt = (jwtToken) => {
  // eslint-disable-next-line no-unused-vars
  const [_, payload] = jwtToken.split(".");
  return JSON.parse(window.atob(payload));
};

export const isAccessExpired = (accessToken) => {
  const { exp } = parseJwt(accessToken);
  const currentTime = Math.trunc(+new Date() / 1000);

  return currentTime >= exp;
};
